import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT } from "@/data/site";
import { SocialLinks } from "./SocialLinks";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#FAFAF7] overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm text-[#5B615A] leading-relaxed">Gartenservice in Bottrop: Gartenpflege, Rasenmähen und Heckenpflege für Privatkunden in Bottrop und Umgebung.</p>
          <div className="mt-6"><SocialLinks /></div>
        </div>
        <div className="md:col-span-4 space-y-1.5 text-[#30352F]">
          <p className="text-xs font-medium uppercase tracking-[0.16em] text-[#2F5D3A] mb-4">Kontakt</p>
          <a href={CONTACT.phoneHref} target="_top" data-testid="footer-phone" className="block hover:text-[#2F5D3A] transition-colors">{CONTACT.phone}</a>
          <a href={CONTACT.emailHref} target="_top" data-testid="footer-email" className="block hover:text-[#2F5D3A] transition-colors">{CONTACT.email}</a>
          <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="block hover:text-[#2F5D3A] transition-colors">WhatsApp</a>
          <p className="pt-2 text-[#5B615A]">Mobiler Gartenservice – wir kommen zu Ihnen.<br />Inhaber: {CONTACT.owner}</p>
        </div>
        <div className="md:col-span-3 space-y-1.5">
          <p className="text-xs font-medium uppercase tracking-[0.16em] text-[#2F5D3A] mb-4">Rechtliches</p>
          <Link to="/impressum" data-testid="footer-link-impressum" className="block text-[#30352F] hover:text-[#2F5D3A] transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-link-datenschutz" className="block text-[#30352F] hover:text-[#2F5D3A] transition-colors">Datenschutz</Link>
        </div>
      </div>
      <p aria-hidden="true" className="mt-16 font-head font-semibold text-[19vw] lg:text-[15.5rem] leading-[0.8] tracking-[-0.06em] text-[#111511]/[0.05] select-none whitespace-nowrap">K&amp;A Garten</p>
      <div className="mt-6 pt-6 border-t border-[#111511]/10 flex flex-col sm:flex-row justify-between gap-2 text-sm text-[#5B615A]">
        <span>© {new Date().getFullYear()} K&amp;A Gartenservice</span>
        <span>Gartenpflege Bottrop · Ruhrgebiet</span>
      </div>
    </div>
  </footer>
);
